import { render, staticRenderFns } from "./ProductsBreakFix.vue?vue&type=template&id=74117f66&scoped=true"
import script from "./ProductsBreakFix.vue?vue&type=script&lang=ts"
export * from "./ProductsBreakFix.vue?vue&type=script&lang=ts"
import style0 from "./Goods.scss?vue&type=style&index=0&id=74117f66&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74117f66",
  null
  
)

export default component.exports